import { BackPressable } from '@/features/auth/components/back-pressable';
import { AuthContainerRoot } from '@/features/auth/components/container';
import { Content } from '@/features/auth/components/content';
import { Hint } from '@/features/auth/components/hint';
import { Logo } from '@/features/auth/components/logo';
import { PlayerPathwayImage } from '@/features/auth/components/player-pathway-image';
import { SocialAuthButton } from '@/features/auth/components/social-auth-button';
import { memo } from 'react';

// Shared building blocks for the gradient-based auth screens (Welcome, Login, Forgot Password).
export { AuthScreenBackground } from '@/features/auth/components/auth-screen-background';
export { AuthBackButton } from '@/features/auth/components/auth-back-button';
export { AuthBrandLogo } from '@/features/auth/components/auth-brand-logo';
export { InputLabel } from '@/features/auth/components/input-label';
export { AuthTextField } from '@/features/auth/components/auth-text-field';
export { AuthPhoneField } from '@/features/auth/components/auth-phone-field';
export { AuthPrimaryButton } from '@/features/auth/components/auth-primary-button';
export { AuthTermsText } from '@/features/auth/components/auth-terms-text';
export { AuthLegalPopup } from '@/features/auth/components/auth-legal-popup';
export { SsoPlayersConsent } from '@/features/auth/components/sso-players-consent';

export const AuthView = Object.assign(AuthContainerRoot, {
  PlayerPathwayImage: memo(PlayerPathwayImage),
  Content: memo(Content),
  Hint: memo(Hint),
  Logo: memo(Logo),
  BackPressable: memo(BackPressable),
  SocialAuthButton,
});
